import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=39f4c9ac&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=39f4c9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4c9ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f4c9ac')) {
      api.createRecord('39f4c9ac', component.options)
    } else {
      api.reload('39f4c9ac', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=39f4c9ac&scoped=true&", function () {
      api.rerender('39f4c9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22Y9J5gGaYK0t/JS/comp/GuestBox.vue"
export default component.exports